import React, { useState, useContext, useEffect } from 'react';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './../../../assets/css/mentor/mentordashboard/Assignments.css';
import MyMasterLayout from './../../../layouts/Mentor/MyMasterlayout';
import axios from 'axios';
import AppContext from './../../../context/Appcontext';


const AssignmentListSkeleton = () => (
  <div className="mentor-assign-container">
    {/* Header */}
    <div className="mentor-assign-header">
      <div className="mentor-assign-header-left">
        <div className="skeleton" style={{ height: 32, width: 180, borderRadius: 8, marginBottom: 10 }} />
        <div className="skeleton" style={{ height: 16, width: 280, borderRadius: 6 }} />
      </div>
      <div className="skeleton" style={{ height: 44, width: 160, borderRadius: 8 }} />
    </div>

    {/* Table */}
    <div className="mentor-assign-students-table mb-4">
      <div className="skeleton" style={{ height: 22, width: 160, borderRadius: 6, marginBottom: 20 }} />
      <div className="mentor-assign-table-wrapper">
        <table className="mentor-assign-table">
          {/* Table Head */}
          <thead>
            <tr>
              {['40px', '200px', '150px', '160px', '130px'].map((w, i) => (
                <th key={i}>
                  <div className="skeleton" style={{ height: 14, width: w, borderRadius: 4 }} />
                </th>
              ))}
            </tr>
          </thead>
          {/* Table Rows */}
          <tbody>
            {[...Array(5)].map((_, i) => (
              <tr key={i}>
                <td><div className="skeleton" style={{ height: 14, width: 24, borderRadius: 4 }} /></td>
                <td><div className="skeleton" style={{ height: 14, width: '80%', borderRadius: 4 }} /></td>
                <td><div className="skeleton" style={{ height: 14, width: '70%', borderRadius: 4 }} /></td>
                <td><div className="skeleton" style={{ height: 14, width: '75%', borderRadius: 4 }} /></td>
                <td>
                  <div style={{ display: 'flex', gap: 8 }}>
                    <div className="skeleton" style={{ height: 34, width: 70, borderRadius: 8 }} />
                    <div className="skeleton" style={{ height: 34, width: 80, borderRadius: 8 }} />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </div>
);

// ---- View 2: Courses View Skeleton ----
const CoursesSkeleton = () => (
  <div className="mentor-assign-container">
    {/* Step Header */}
    <div className="mentor-assign-step-header">
      <div className="skeleton" style={{ height: 40, width: 90, borderRadius: 8 }} />
      <div>
        <div className="skeleton" style={{ height: 28, width: 200, borderRadius: 6, marginBottom: 10 }} />
        <div className="skeleton" style={{ height: 16, width: 300, borderRadius: 5 }} />
      </div>
    </div>

    {/* Course Cards Grid */}
    <div className="mentor-assign-courses-grid">
      {[...Array(3)].map((_, i) => (
        <div key={i} className="mentor-assign-course-card" style={{ pointerEvents: 'none' }}>
          {/* Icon */}
          <div className="skeleton skeleton-circle" style={{ width: 64, height: 64, borderRadius: 12, marginBottom: 20 }} />
          {/* Title */}
          <div className="skeleton" style={{ height: 22, width: '70%', borderRadius: 6, marginBottom: 10 }} />
          {/* Description */}
          <div className="skeleton" style={{ height: 14, width: '90%', borderRadius: 4, marginBottom: 6 }} />
          <div className="skeleton" style={{ height: 14, width: '75%', borderRadius: 4, marginBottom: 20 }} />
          {/* Footer */}
          <div className="mentor-assign-course-meta" style={{ borderTop: '1px solid #e2e8f0', paddingTop: 16 }}>
            <div className="skeleton" style={{ height: 14, width: 80, borderRadius: 4 }} />
            <div className="skeleton" style={{ height: 20, width: 20, borderRadius: 4 }} />
          </div>
        </div>
      ))}
    </div>
  </div>
);

// ---- View 3: Subjects View Skeleton ----
const SubjectsSkeleton = () => (
  <div className="mentor-assign-container">
    {/* Step Header */}
    <div className="mentor-assign-step-header">
      <div className="skeleton" style={{ height: 40, width: 90, borderRadius: 8 }} />
      <div>
        {/* Breadcrumb */}
        <div className="skeleton" style={{ height: 14, width: 160, borderRadius: 4, marginBottom: 10 }} />
        <div className="skeleton" style={{ height: 28, width: 180, borderRadius: 6, marginBottom: 8 }} />
        <div className="skeleton" style={{ height: 16, width: 300, borderRadius: 5 }} />
      </div>
    </div>

    {/* Subject Cards */}
    <div className="mentor-assign-subjects-grid">
      {[...Array(4)].map((_, i) => (
        <div key={i} className="mentor-assign-subject-card" style={{ pointerEvents: 'none' }}>
          {/* Icon */}
          <div className="skeleton" style={{ width: 48, height: 48, borderRadius: 10, flexShrink: 0 }} />
          {/* Title */}
          <div className="skeleton" style={{ height: 18, flex: 1, borderRadius: 5 }} />
          {/* Arrow */}
          <div className="skeleton" style={{ width: 32, height: 32, borderRadius: 8, flexShrink: 0 }} />
        </div>
      ))}
    </div>
  </div>
);

// ---- View 4: Form View Skeleton ----
const FormSkeleton = () => (
  <div className="mentor-assign-container">
    {/* Step Header */}
    <div className="mentor-assign-step-header">
      <div className="skeleton" style={{ height: 40, width: 90, borderRadius: 8 }} />
      <div>
        <div className="skeleton" style={{ height: 14, width: 180, borderRadius: 4, marginBottom: 10 }} />
        <div className="skeleton" style={{ height: 28, width: 220, borderRadius: 6, marginBottom: 8 }} />
        <div className="skeleton" style={{ height: 16, width: 260, borderRadius: 5 }} />
      </div>
    </div>

    {/* Form */}
    <div className="mentor-assign-form">
      {/* Assignment Title field */}
      <div className="mentor-assign-form-group">
        <div className="skeleton" style={{ height: 16, width: 140, borderRadius: 4, marginBottom: 10 }} />
        <div className="skeleton" style={{ height: 48, width: '100%', borderRadius: 8 }} />
      </div>

      {/* Instructions field */}
      <div className="mentor-assign-form-group">
        <div className="skeleton" style={{ height: 16, width: 110, borderRadius: 4, marginBottom: 10 }} />
        <div className="skeleton" style={{ height: 140, width: '100%', borderRadius: 8 }} />
      </div>

      {/* Due Date field */}
      <div className="mentor-assign-form-group">
        <div className="skeleton" style={{ height: 16, width: 160, borderRadius: 4, marginBottom: 10 }} />
        <div className="skeleton" style={{ height: 48, width: '100%', borderRadius: 8 }} />
      </div>

      {/* Attachment field */}
      <div className="mentor-assign-form-group">
        <div className="skeleton" style={{ height: 16, width: 180, borderRadius: 4, marginBottom: 10 }} />
        <div className="skeleton" style={{ height: 52, width: '100%', borderRadius: 8 }} />
      </div>

      {/* Notice box */}
      <div className="skeleton" style={{ height: 56, width: '100%', borderRadius: 8, marginBottom: 24 }} />

      {/* Action buttons */}
      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 12, paddingTop: 16, borderTop: '1px solid #e2e8f0' }}>
        <div className="skeleton" style={{ height: 44, width: 100, borderRadius: 8 }} />
        <div className="skeleton" style={{ height: 44, width: 160, borderRadius: 8 }} />
      </div>
    </div>
  </div>
);

// =============================================
//  MAIN COMPONENT
// =============================================
const Assignments = () => {
  const { baseUrl } = useContext(AppContext);

  const [createStep, setCreateStep] = useState('list');
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [selectedSubject, setSelectedSubject] = useState(null);
  const [assignments, setAssignments] = useState([]);
  const [editingAssignment, setEditingAssignment] = useState(null);

  const [title, setTitle] = useState('');
  const [instructions, setInstructions] = useState('');
  const [dueDate, setDueDate] = useState('');
  const [attachment, setAttachment] = useState(null);

  const [isLoading, setIsLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(null);
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [assignmentToDelete, setAssignmentToDelete] = useState(null);

  const students = [
    { id: 1, name: 'Ali Khan', email: 'ali@example.com', status: 'pending', submitted: false },
    { id: 2, name: 'Sara Ahmed', email: 'sara@example.com', status: 'submitted', submitted: true },
    { id: 3, name: 'Hassan Ali', email: 'hassan@example.com', status: 'pending', submitted: false },
    { id: 4, name: 'Ayesha Malik', email: 'ayesha@example.com', status: 'submitted', submitted: true },
    { id: 5, name: 'Usman Raza', email: 'usman@example.com', status: 'late', submitted: false }
  ];

  const courses = [
    {
      id: 1,
      title: 'Web Dev Fundamentals',
      description: 'Master the basics of web development',
      subjects: ['HTML Basics', 'CSS Styling', 'JavaScript Intro', 'Responsive Design'],
      icon: 'bi-code-slash',
      color: '#3b82f6'
    },
    {
      id: 2,
      title: 'Advanced JavaScript',
      description: 'Deep dive into modern JavaScript',
      subjects: ['ES6+ Features', 'Async Programming', 'DOM Manipulation', 'APIs & Fetch'],
      icon: 'bi-lightning-charge',
      color: '#8b5cf6'
    },
    {
      id: 3,
      title: 'React Mastery',
      description: 'Build modern web applications',
      subjects: ['React Hooks', 'State Management', 'React Router', 'Component Patterns'],
      icon: 'bi-bezier2',
      color: '#06b6d4'
    }
  ];

  const fetchAssignments = () => {
    const mentorData = JSON.parse(localStorage.getItem('mentorData'));
    if (!mentorData) return;
    setIsLoading(true);
    axios.get(`${baseUrl}/assignment/list/${mentorData.id}`)
      .then((response) => {
        setAssignments(response.data.assignments || []);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error('Fetch error:', error);
        setIsLoading(false);
      });
  };

  useEffect(() => { fetchAssignments(); }, []);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const validTypes = [
        'application/pdf',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/zip'
      ];
      if (validTypes.includes(file.type)) {
        setAttachment(file);
      } else {
        setErrorMessage('Please upload PDF, DOC, DOCX or ZIP files only');
      }
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setErrorMessage(''); setSuccessMessage('');
    if (!title || !instructions || !dueDate) { setErrorMessage('Please fill in all required fields'); return; }
    setIsLoading(true);
    const mentorData = JSON.parse(localStorage.getItem('mentorData'));
    const data = new FormData();
    data.append('mentor_id', mentorData.id);
    data.append('assignment_title', title);
    data.append('instructions', instructions);
    data.append('due_date_time', dueDate);
    data.append('course_name', selectedCourse.title);
    if (attachment) data.append('attachment', attachment);
    axios.post(`${baseUrl}/assignment/create`, data, { headers: { 'Content-Type': 'multipart/form-data' } })
      .then(() => {
        setIsLoading(false); setSuccessMessage('Assignment created successfully!');
        resetForm(); fetchAssignments();
        setTimeout(() => { setSuccessMessage(''); setCreateStep('list'); }, 1500);
      })
      .catch((error) => { setIsLoading(false); handleApiError(error); });
  };

  const handleUpdate = (e) => {
    e.preventDefault();
    setErrorMessage(''); setSuccessMessage('');
    if (!title || !instructions || !dueDate) { setErrorMessage('Please fill in all required fields'); return; }
    setIsLoading(true);
    const data = new FormData();
    data.append('_method', 'Post');
    data.append('assignment_title', title);
    data.append('instructions', instructions);
    data.append('due_date_time', dueDate);
    data.append('course_name', selectedCourse ? selectedCourse.title : editingAssignment.course_name);
    if (attachment) data.append('attachment', attachment);
    axios.post(`${baseUrl}/assignment/update/${editingAssignment.id}`, data, { headers: { 'Content-Type': 'multipart/form-data' } })
      .then(() => {
        setIsLoading(false); setSuccessMessage('Assignment updated successfully!');
        fetchAssignments();
        setTimeout(() => { setSuccessMessage(''); setCreateStep('list'); setEditingAssignment(null); resetForm(); }, 1500);
      })
      .catch((error) => { setIsLoading(false); handleApiError(error); });
  };

  const handleDelete = () => {
    if (!assignmentToDelete) return;
    setDeleteLoading(assignmentToDelete.id); setShowDeleteModal(false);
    axios.delete(`${baseUrl}/assignment/delete/${assignmentToDelete.id}`)
      .then(() => {
        setDeleteLoading(null); setAssignmentToDelete(null);
        setSuccessMessage('Assignment deleted successfully!');
        fetchAssignments();
        setTimeout(() => setSuccessMessage(''), 2000);
      })
      .catch((error) => { setDeleteLoading(null); handleApiError(error); });
  };

  const handleEditClick = (assignment) => {
    setEditingAssignment(assignment); setTitle(assignment.assignment_title);
    setInstructions(assignment.instructions);
    if (assignment.due_date_time) {
      setDueDate(assignment.due_date_time.replace(' ', 'T').slice(0, 16));
    }
    setAttachment(null); setErrorMessage(''); setSuccessMessage('');
    setCreateStep('form');
  };

  const handleDeleteClick = (assignment) => {
    setAssignmentToDelete(assignment); setShowDeleteModal(true);
  };

  const resetForm = () => {
    setTitle(''); setInstructions(''); setDueDate('');
    setAttachment(null); setSelectedCourse(null);
    setSelectedSubject(null); setEditingAssignment(null);
  };

  const handleApiError = (error) => {
    console.error('API error:', error);
    if (error.response?.data) {
      if (error.response.data.errors) {
        setErrorMessage(Object.values(error.response.data.errors).flat().join(', '));
      } else if (error.response.data.message) {
        setErrorMessage(error.response.data.message);
      } else {
        setErrorMessage('Something went wrong. Please try again.');
      }
    } else {
      setErrorMessage('Network error. Please check your connection.');
    }
  };

  const handleBack = () => {
    if (createStep === 'form') {
      if (editingAssignment) { setCreateStep('list'); resetForm(); }
      else { setCreateStep('subjects'); setSelectedSubject(null); }
    } else if (createStep === 'subjects') {
      setCreateStep('courses'); setSelectedSubject(null);
    } else if (createStep === 'courses') {
      setCreateStep('list'); setSelectedCourse(null);
    }
  };

  const handleSelectCourse = (course) => { setSelectedCourse(course); setCreateStep('subjects'); };
  const handleSelectSubject = (subject) => { setSelectedSubject(subject); setCreateStep('form'); };

  // ========== RENDER LIST VIEW ==========
  const renderListView = () => {
    // Show skeleton while loading
    if (isLoading) return <AssignmentListSkeleton />;

    return (
      <div className="mentor-assign-container">
        <div className="mentor-assign-header">
          <div className="mentor-assign-header-left">
            <h2 className="mentor-assign-title">Assignments</h2>
            <p className="mentor-assign-subtitle">Create and manage student assignments</p>
          </div>
          <button
            className="mentor-assign-create-btn"
            onClick={() => { resetForm(); setCreateStep('courses'); }}
          >
            <i className="bi bi-plus-circle"></i> Create Assignment
          </button>
        </div>

        {successMessage && (
          <div className="alert alert-success py-2 mb-3">
            <i className="bi bi-check-circle me-2"></i>{successMessage}
          </div>
        )}

        <div className="mentor-assign-students-table mb-4">
          <h3 className="mentor-assign-table-title">All Assignments</h3>
          {assignments.length === 0 ? (
            <div className="text-center py-4 text-muted">
              No assignments found. Click "Create Assignment" to add one.
            </div>
          ) : (
            <div className="mentor-assign-table-wrapper">
              <table className="mentor-assign-table">
                <thead>
                  <tr>
                    <th>#</th><th>Title</th><th>Course</th><th>Due Date</th><th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {assignments.map((assignment, index) => (
                    <tr key={assignment.id}>
                      <td>{index + 1}</td>
                      <td>{assignment.assignment_title}</td>
                      <td>{assignment.course_name}</td>
                      <td>{assignment.due_date_time ? new Date(assignment.due_date_time).toLocaleString() : '-'}</td>
                      <td>
                        <button className="mentor-assign-action-btn me-2" onClick={() => handleEditClick(assignment)} title="Edit">
                          <i className="bi bi-pencil-square"></i> Edit
                        </button>
                        <button
                          className="mentor-assign-action-btn btn-danger-outline"
                          onClick={() => handleDeleteClick(assignment)}
                          disabled={deleteLoading === assignment.id}
                          title="Delete"
                        >
                          {deleteLoading === assignment.id
                            ? <span className="spinner-border spinner-border-sm"></span>
                            : <><i className="bi bi-trash"></i> Delete</>}
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    );
  };

  // ========== RENDER COURSES VIEW ==========
  const renderCoursesView = () => {
    if (isLoading) return <CoursesSkeleton />;

    return (
      <div className="mentor-assign-container">
        <div className="mentor-assign-step-header">
          <button className="mentor-assign-back-btn" onClick={handleBack}>
            <i className="bi bi-arrow-left"></i> Back
          </button>
          <div>
            <h2 className="mentor-assign-step-title">Select Course</h2>
            <p className="mentor-assign-step-subtitle">Choose which course this assignment is for</p>
          </div>
        </div>
        <div className="mentor-assign-courses-grid">
          {courses.map(course => (
            <div key={course.id} className="mentor-assign-course-card" onClick={() => handleSelectCourse(course)} style={{ '--course-color': course.color }}>
              <div className="mentor-assign-course-icon"><i className={`bi ${course.icon}`}></i></div>
              <h3 className="mentor-assign-course-title">{course.title}</h3>
              <p className="mentor-assign-course-description">{course.description}</p>
              <div className="mentor-assign-course-meta">
                <span className="mentor-assign-course-count">{course.subjects.length} subjects</span>
                <i className="bi bi-arrow-right mentor-assign-course-arrow"></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  // ========== RENDER SUBJECTS VIEW ==========
  const renderSubjectsView = () => {
    if (isLoading) return <SubjectsSkeleton />;

    return (
      <div className="mentor-assign-container">
        <div className="mentor-assign-step-header">
          <button className="mentor-assign-back-btn" onClick={handleBack}>
            <i className="bi bi-arrow-left"></i> Back
          </button>
          <div>
            <div className="mentor-assign-breadcrumb">
              <span>{selectedCourse?.title}</span>
              <i className="bi bi-chevron-right"></i>
              <span>Subject</span>
            </div>
            <h2 className="mentor-assign-step-title">Select Subject</h2>
            <p className="mentor-assign-step-subtitle">Choose the specific subject for this assignment</p>
          </div>
        </div>
        <div className="mentor-assign-subjects-grid">
          {selectedCourse?.subjects.map((subject, index) => (
            <div key={index} className="mentor-assign-subject-card" onClick={() => handleSelectSubject(subject)}>
              <div className="mentor-assign-subject-icon"><i className="bi bi-book"></i></div>
              <h3 className="mentor-assign-subject-title">{subject}</h3>
              <div className="mentor-assign-subject-arrow"><i className="bi bi-arrow-right"></i></div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  // ========== RENDER FORM VIEW ==========
  const renderFormView = () => {
    if (isLoading) return <FormSkeleton />;

    return (
      <div className="mentor-assign-container">
        <div className="mentor-assign-step-header">
          <button className="mentor-assign-back-btn" onClick={handleBack}>
            <i className="bi bi-arrow-left"></i> Back
          </button>
          <div>
            <div className="mentor-assign-breadcrumb">
              <span>{selectedCourse?.title || editingAssignment?.course_name}</span>
              {selectedSubject && (<><i className="bi bi-chevron-right"></i><span>{selectedSubject}</span></>)}
            </div>
            <h2 className="mentor-assign-step-title">{editingAssignment ? 'Edit Assignment' : 'Create Assignment'}</h2>
            <p className="mentor-assign-step-subtitle">{editingAssignment ? 'Update the assignment details' : 'Fill in the assignment details'}</p>
          </div>
        </div>

        <form className="mentor-assign-form" onSubmit={editingAssignment ? handleUpdate : handleSubmit}>
          {errorMessage && (
            <div className="alert alert-danger py-2 mb-3">
              <i className="bi bi-exclamation-triangle me-2"></i>{errorMessage}
            </div>
          )}
          {successMessage && (
            <div className="alert alert-success py-2 mb-3">
              <i className="bi bi-check-circle me-2"></i>{successMessage}
            </div>
          )}

          <div className="mentor-assign-form-group">
            <label className="mentor-assign-form-label">Assignment Title <span className="mentor-assign-required">*</span></label>
            <input type="text" className="mentor-assign-form-input" placeholder="e.g., Build a Responsive Landing Page" value={title} onChange={(e) => setTitle(e.target.value)} required />
          </div>

          <div className="mentor-assign-form-group">
            <label className="mentor-assign-form-label">Instructions <span className="mentor-assign-required">*</span></label>
            <textarea className="mentor-assign-form-textarea" placeholder="Provide detailed instructions for the assignment..." rows="6" value={instructions} onChange={(e) => setInstructions(e.target.value)} required />
          </div>

          <div className="mentor-assign-form-group">
            <label className="mentor-assign-form-label">Due Date & Time <span className="mentor-assign-required">*</span></label>
            <input type="datetime-local" className="mentor-assign-form-input" value={dueDate} onChange={(e) => setDueDate(e.target.value)} required />
          </div>

          <div className="mentor-assign-form-group">
            <label className="mentor-assign-form-label">Attachment {editingAssignment ? '(Leave empty to keep existing)' : '(Optional)'}</label>
            <div className="mentor-assign-file-upload">
              <input type="file" id="assignmentFile" className="mentor-assign-file-input" accept=".pdf,.doc,.docx,.zip" onChange={handleFileChange} />
              <label htmlFor="assignmentFile" className="mentor-assign-file-label">
                <i className="bi bi-paperclip"></i>
                {attachment ? attachment.name : 'Choose file (PDF, DOC, ZIP)'}
              </label>
            </div>
            {editingAssignment && editingAssignment.attachment && !attachment && (
              <small className="text-muted mt-1 d-block">
                <i className="bi bi-file-earmark me-1"></i>Current: {editingAssignment.attachment}
              </small>
            )}
          </div>

          <div className="mentor-assign-notice">
            <i className="bi bi-info-circle"></i>
            <p>
              This assignment will be visible to all students enrolled in{' '}
              <strong>{selectedCourse?.title || editingAssignment?.course_name}</strong>
              {selectedSubject && <> - <strong>{selectedSubject}</strong></>}
            </p>
          </div>

          <div className="mentor-assign-form-actions">
            <button type="button" className="mentor-assign-cancel-btn" onClick={handleBack}>Cancel</button>
            <button type="submit" className="mentor-assign-submit-btn" disabled={isLoading}>
              {isLoading
                ? <><span className="spinner-border spinner-border-sm me-2"></span>{editingAssignment ? 'Updating...' : 'Creating...'}</>
                : <><i className="bi bi-check-circle me-2"></i>{editingAssignment ? 'Update Assignment' : 'Create Assignment'}</>}
            </button>
          </div>
        </form>
      </div>
    );
  };

  return (
    <MyMasterLayout>
      <div className="mentor-assign-wrapper">
        {createStep === 'list'     && renderListView()}
        {createStep === 'courses'  && renderCoursesView()}
        {createStep === 'subjects' && renderSubjectsView()}
        {createStep === 'form'     && renderFormView()}
      </div>
    </MyMasterLayout>
  );
};

export default Assignments;